import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/actions/auth";
import IconImage from "../image/neqst1.ico";

export default function Header(props) {
  const style = {
    top: "50%",
    position: "absolute",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 250,
    bgcolor: "background.paper",
    border: "2px solid rgba(149, 205, 240, 0.68)",
    boxShadow: 24,
    p: 4
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();
  const LogoutSubmit = async data => {
    dispatch(logout(data));
  };
  const user = useSelector(state => state.auth.user);
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
  return (
    <React.Fragment>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" sx={{ bgcolor: "green" }}>
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontSize:[10, 15, 20] }} textAlign="left" whiteSpace={"nowrap"}>
              {`${process.env.REACT_APP_SCHOOL_NAME}`}
            </Typography>
            {isLoggedIn &&
              <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontSize:[10, 15, 20] }} textAlign="center" whiteSpace={"nowrap"}>
                ログインユーザ：{user ? user.name : ""}
              </Typography>}
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={handleOpen}
              >
                <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontSize:[10, 15, 20] }} textAlign="center" whiteSpace={"nowrap"}>
                  ログアウト
                </Typography>
              </IconButton>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
              >
                <Avatar alt="NEXT" variant="rounded" src={IconImage} />
              </IconButton>
              <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    ログアウトしますか？
                  </Typography>
                  <Stack sx={{ pt: 4 }} direction="row" spacing={3} justifyContent="right">
                    <Button variant="contained" size="small" href="/" onClick={LogoutSubmit}>
                      はい
                    </Button>
                    <Button variant="contained" size="small" onClick={handleClose}>
                      いいえ
                    </Button>
                  </Stack>
                </Box>
              </Modal>
            </div>
          </Toolbar>
        </AppBar>
      </Box>
    </React.Fragment>
  );
}
